import {
  EuiButtonIcon,
  EuiDescriptionList,
  EuiScreenReaderOnly,
  formatDate,
  RIGHT_ALIGNMENT,
} from "@elastic/eui";
import React, { useState, Fragment, useRef, useEffect } from "react";

import uniqBy from "lodash/uniqBy";
import {
  EuiLink,
  EuiHealth,
  EuiButton,
  EuiInMemoryTable,
  EuiEmptyPrompt,
  EuiSpacer,
} from "@elastic/eui";

import AxiosConfig from "../../common/axiosConfig";

const noItemsFoundMsg = "No Invoices match search criteria";

const InMemoryTable = () => {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [message, setMessage] = useState(
    <EuiEmptyPrompt
      title={<h3>No Invoices</h3>}
      titleSize="xs"
      body="Looks like you don&rsquo;t have any invoices. Let&rsquo;s create some!"
      actions={
        <EuiButton
          size="s"
          key="loadInvoices"
          onClick={() => {
            loadInvoices();
          }}
        >
          Load Invoices
        </EuiButton>
      }
    />
  );

  const [selection, setSelection] = useState([]);
  const [error, setError] = useState();
  const [itemIdToExpandedRowMap, setItemIdToExpandedRowMap] = useState({});
  const tableRef = useRef();

  const loadInvoices = () => {
    setMessage("Loading Invoices...");
    setLoading(true);
    setInvoices([]);
    setError(undefined);
    AxiosConfig.post("/v1/invoice/get-all-invoices")
      .then(({ data }) => {
        setLoading(false);
        setMessage(noItemsFoundMsg);
        setError(undefined);
        setInvoices(data);
      })
      .catch((e) => {
        setLoading(false);
        setMessage(noItemsFoundMsg);
        setError("ouch!... again... ");
        setInvoices([]);
      });
  };

  const toggleDetails = (item) => {
    const itemIdToExpandedRowMapValues = { ...itemIdToExpandedRowMap };
    if (itemIdToExpandedRowMapValues[item.id]) {
      delete itemIdToExpandedRowMapValues[item.id];
    } else {
      const { listOfPurchases = [] } = item;
      // const color = online ? 'success' : 'danger';
      // const label = online ? 'Online' : 'Offline';

      itemIdToExpandedRowMapValues[item.id] = listOfPurchases.map(
        ({ quantity, price, total, gasTypeName, productCode }) => {
          const listItems = [
            {
              title: "gas Name",
              description: gasTypeName,
            },
            {
              title: "Quantity",
              description: quantity,
            },
            {
              title: "Price",
              description: price,
            },
            {
              title: "Total",
              description: total,
            },
          ];
          return <EuiDescriptionList listItems={listItems} />;
        }
      );
    }
    setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
  };
  const renderToolsLeft = () => {
    if (selection.length === 0) {
      return;
    }

    const onClick = () => {
      // DELETE INVOICES HERE
      //   store.deleteUsers(...selection.map((user) => user.id));
      //   setSelection([]);
    };

    return (
      <EuiButton color="danger" iconType="trash" onClick={onClick}>
        Delete {selection.length} Invoices
      </EuiButton>
    );
  };

  useEffect(() => {
    loadInvoices();
  }, []);

  const renderToolsRight = () => {
    return [
      <EuiButton
        key="loadInvoices"
        onClick={() => {
          loadInvoices();
        }}
        isDisabled={loading}
      >
        Load Invoices
      </EuiButton>,
    ];
  };

  const columns = [
    {
      field: "invoiceNo",
      name: "Invoice Number",
      sortable: true,
      truncateText: true,
      mobileOptions: {
        render: (item) => <span></span>,
        header: false,
        truncateText: false,
        enlarge: true,
        width: "100%",
      },
    },
    {
      field: "invoiceDateTime",
      name: "Invoice Date",
      schema: "date",
      render: (date) => formatDate(date, "dobLong"),
      sortable: true,
    },
    {
      field: "soldTo",
      name: "Company",
      truncateText: true,
      sortable: true,
      mobileOptions: {
        show: false,
      },
      footer: ({ items }) => (
        <span>{uniqBy(items, "soldTo").length} Companies</span>
      ),
    },
    {
      field: "to",
      name: "Address",
      truncateText: true,
      sortable: true,
      mobileOptions: {
        show: false,
      },
      footer: ({ items }) => <span>{uniqBy(items, "to").length} Places</span>,
    },

    {
      field: "totalAmount",
      name: "Amount",
      sortable: true,
      truncateText: true,
      mobileOptions: {
        show: false,
      },
    },
    {
      name: "Actions",
      actions: [
        {
          name: "Edit",
          description: "Edit Pdf",
          type: "icon",
          icon: "pencil",
          onClick: () => "",
        },
        {
          name: "View",
          description: "View Pdf",
          type: "icon",
          icon: "inspect",
          onClick: () => "",
        },
        {
          name: "Download",
          description: "Download Entry",
          type: "icon",
          icon: "download",
          onClick: () => "",
        },
        {
          name: "Delete",
          description: "Delete Entry",
          type: "icon",
          icon: "trash",
          onClick: () => "",
        },
      ],
    },
    {
      align: RIGHT_ALIGNMENT,
      width: "40px",
      isExpander: true,
      name: (
        <EuiScreenReaderOnly>
          <span>Expand rows</span>
        </EuiScreenReaderOnly>
      ),
      render: (item) => (
        <EuiButtonIcon
          onClick={() => toggleDetails(item)}
          aria-label={itemIdToExpandedRowMap[item.id] ? "Collapse" : "Expand"}
          iconType={itemIdToExpandedRowMap[item.id] ? "arrowUp" : "arrowDown"}
        />
      ),
    },
  ];
  const search = {
    toolsLeft: renderToolsLeft(),
    toolsRight: renderToolsRight(),
    box: {
      incremental: true,
    },
    filters: [
      {
        type: "field_value_selection",
        field: "to",
        name: "Address",
        multiSelect: true,
        options: uniqBy(invoices, "to").map((el) => ({
          value: el.to,
          name: el.to,
          view: el.to,
        })),
      },
      {
        type: "field_value_selection",
        field: "soldTo",
        name: "Company",
        multiSelect: true,
        options: uniqBy(invoices, "soldTo").map((el) => ({
          value: el.soldTo,
          name: el.soldTo,
          view: el.soldTo,
        })),
      },
    ],
  };

  const pagination = {
    initialPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
  };

  const selectionValue = {
    selectable: () => true,
    selectableMessage: () => undefined,
    onSelectionChange: (selection) => setSelection(selection),
    initialSelected: [],
  };

  return (
    <Fragment>
      <EuiSpacer size="l" />

      <EuiInMemoryTable
        tableCaption="Demo of EuiInMemoryTable with selection"
        ref={tableRef}
        items={invoices}
        itemIdToExpandedRowMap={itemIdToExpandedRowMap}
        itemId="id"
        error={error}
        loading={loading}
        message={message}
        columns={columns}
        search={search}
        pagination={pagination}
        sorting={true}
        selection={selectionValue}
        isSelectable={true}
      />
    </Fragment>
  );
};

export default InMemoryTable;
